/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { creteMessageModelSchema } from "../creteMessageModelSchema.ts";
import { guidCreatedOrUpdatedEntityModelSchema } from "../guidCreatedOrUpdatedEntityModelSchema.ts";
import { z } from "zod";

export const postApiFeedbacksIdMessagesPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор чата")
    })

/**
 * @description Идентификатор созданного сообщения
 */
export const postApiFeedbacksIdMessages200Schema = z.lazy(() => guidCreatedOrUpdatedEntityModelSchema)

/**
 * @description Ошибка валидации
 */
export const postApiFeedbacksIdMessages400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const postApiFeedbacksIdMessages401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const postApiFeedbacksIdMessages403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не найден | Чат не найден
 */
export const postApiFeedbacksIdMessages404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const postApiFeedbacksIdMessages500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса
 */
export const postApiFeedbacksIdMessagesMutationRequestSchema = z.lazy(() => creteMessageModelSchema).describe("Тело запроса")

export const postApiFeedbacksIdMessagesMutationResponseSchema = z.lazy(() => postApiFeedbacksIdMessages200Schema)